import React from 'react';
import { SideSheet, SideSheetProps } from 'pounceV2';
import { LogStreamType } from 'Generated/schema';
import ViewBucketDataSideSheetContentV3 from './ViewBucketDataSideSheetContentV3';
import ViewBucketDataSideSheetTitleV3 from './ViewBucketDataSideSheetTitleV3';

export type ViewBucketDataSideSheetProps = {
  sourceId: string;
  streamType: LogStreamType;
  prefix: string;
} & SideSheetProps;

const ViewBucketDataSideSheetV3 = ({
  open,
  onClose,
  prefix,
  streamType,
  sourceId,
}: ViewBucketDataSideSheetProps) => {
  return (
    <SideSheet
      aria-label="Quick S3 Object Event Preview"
      width="max(560px, 50vw)"
      containerProps={{ p: 0 }}
      hideDismissIcon
      open={open}
      onClose={onClose}
    >
      <ViewBucketDataSideSheetTitleV3 title={prefix} onClose={onClose} />
      <ViewBucketDataSideSheetContentV3
        prefix={prefix}
        show={open}
        streamType={streamType}
        sourceId={sourceId}
      />
    </SideSheet>
  );
};

export default ViewBucketDataSideSheetV3;
